export type ServiceOption = {
  id: string;
  title: string;
  description: string;
  icon: string;
};

export const services: ServiceOption[] = [
  {
    id: 'social-media',
    title: 'Gestão de Redes Sociais',
    description: 'Planejamento e produção de conteúdo.',
    icon: 'Smartphone'
  },
  {
    id: 'paid-traffic',
    title: 'Tráfego Pago',
    description: 'Campanhas para gerar resultados.',
    icon: 'Target'
  },
  {
    id: 'visual-identity',
    title: 'Identidade Visual',
    description: 'Logos, branding e design.',
    icon: 'Palette'
  },
  {
    id: 'web-development',
    title: 'Desenvolvimento Web',
    description: 'Sites, landing pages e lojas virtuais.',
    icon: 'Globe2'
  },
  {
    id: 'biolinks',
    title: 'Biolinks',
    description: 'Links inteligentes para sua marca.',
    icon: 'Link2'
  },
  {
    id: 'content-production',
    title: 'Produção de Conteúdo',
    description: 'Fotos, vídeos e materiais para redes sociais.',
    icon: 'Camera'
  },
  {
    id: 'not-sure',
    title: 'Ainda não sei',
    description: 'Quero conversar e entender a melhor solução.',
    icon: 'Lightbulb'
  }
];
